interface RouteOptions {
  hasBottomNav?: boolean;
}

type DynamicParams = Record<string, string | number | null | boolean>;

export const createRoute = <
  TDynamicParams extends {
    dynamicPath?: DynamicParams;
    searchParams?: DynamicParams;
  } = {
    dynamicPath: undefined;
    searchParams: undefined;
  },
>(
  pathname: TDynamicParams['dynamicPath'] extends DynamicParams
    ? (dynamicPath: TDynamicParams['dynamicPath']) => string
    : string,
  options?: RouteOptions,
) => {
  return Object.freeze({
    pathname,
    withSearchParams: (dynamicParams: TDynamicParams) => {
      const params = dynamicParams.searchParams ?? {};
      const searchParams = new URLSearchParams();

      for (const key in params) {
        const value = params[key];

        if (value === undefined) continue;

        searchParams.append(key, String(value));
      }

      const search = searchParams.toString();

      const _pathname =
        typeof pathname === 'function'
          ? pathname(dynamicParams.dynamicPath ?? {})
          : pathname;

      return `${_pathname}${search ? `?${search}` : ''}`;
    },
    hasBottomNav: options?.hasBottomNav ?? true,
  } as const);
};
